
const blackBox = [
  {
    id: 1,
    title: 'clarityIsEasy',
    description: [
      'forgetAboutDoubleBooking'
    ]
  },
  {
    id: 2,
    title: 'optimizeTheUse',
    description: [
      'increaseTheMeeting'
    ]
  },
  {
    id: 3,
    title: 'happyItDepartment',
    description: [
      "aPatentPending",
      "turnkeySolution",
      "remoteManagement",
    ]
  },
  {
    id: 4,
    title: 'contestWinner',
    description: [
      "goodDesign",
      "dfaAward",
      "bestDigital",
      "ifProductDesign"
    ]
  },
]

export {
  blackBox,
}